module.exports = __webpack_public_path__ + "static/media/HARD_LEFT.40b90426.svg";